// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + {"2654":"f1793bb2b56480d1","8795":"bc21ecffb4c56e56"}[chunkId] + ".css";
};